import { useState } from "react";
import {
  RequestCancelInboundPlansRequest,
  AmazonCancelInboundPlansPostRequest,
  AmazonApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";
import { isLwaNotConnectedError } from "../../utils/lwaError";

export const useApiCancelInboundPlan = () => {
  const [resultCancel, setResultCancelr] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const cancelInboundPlan = async (
    req: RequestCancelInboundPlansRequest
  ): Promise<{ ok: boolean; notConnected: boolean }> => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: AmazonCancelInboundPlansPostRequest = {
        req,
      };

      const api = new AmazonApi(config);
      const response = await api.amazonCancelInboundPlansPost(request);
      setResultCancelr(response);
      return { ok: response, notConnected: false };
    } catch (err: any) {
      const notConnected = isLwaNotConnectedError(err);
      setError(notConnected ? "LWA_NOT_CONNECTED" : "プランキャンセルに失敗しました");
      return { ok: false, notConnected };
    } finally {
      setIsLoading(false);
    }
  };

  return { cancelInboundPlan, resultCancel, error, isLoading };
};
